import React, { useCallback, useContext, useEffect, useRef } from 'react'
import { Router, Link, navigate, RouteComponentProps, globalHistory } from '@reach/router'
import Login from './components/Login'
import Logout from './components/Logout'
import FakeSSO from './components/FakeSSO/FakeSSO'
import ServiceRequests from './components/ServiceRequests'
import PrivateRoute from './components/Common/PrivateRoute'
import EnvironmentName from './components/Common/EnvironmentName'
import IdleTimer from 'react-idle-timer'
import Cookies from 'js-cookie'
import Preferences from './components/Preferences'
import GuidingCareReplicaAdmin from './components/Admin/GuidingCareReplicaAdmin'
import ProviderPreferenceOverrides from './components/Admin/ProviderPreferenceOverrides'
import Notifications from './components/Notifications'
import UserContext from './UserContext'
import { PageView } from './components/Common/AnalyticsEvents'

const configData = window.CS_CONFIG

const Home: React.FC<RouteComponentProps> = () => {
    const { user: { token } } = useContext(UserContext)
    
    // eslint-disable-next-line no-console
    console.log('Auth redirect check', !!token, !!Cookies.get('cs_id_token'), Cookies.get('cs_id_token') ? `${Cookies.get('cs_id_token')?.substring(0, 10) as string} ...` : 'no token', 'hap?', Cookies.get('cs_hap'))
    if (Cookies.get('cs_id_token') && token) {
        const callback = sessionStorage.getItem('path-callback')
        if (callback) {
            sessionStorage.removeItem('path-callback')
            setTimeout(() => void navigate(callback), 100)
        } else {
            setTimeout(() => void navigate('service-requests'), 100)
        }
    }
    if (!Cookies.get('cs_id_token')) setTimeout(() => { 
        if (Cookies.get('cs_hap')) { //last time we used HAP so try going back there
            Cookies.remove('cs_hap')
            window.location.replace(configData.HAPLink)
        }
        else
            void navigate('login')
    }, 100)
    
    return null
}

const App: React.FC = () => {
    const idleTimer = useRef<IdleTimer>(null)

    // eslint-disable-next-line no-console
    console.log('Loading', window.location.href)

    const handleOnIdle = useCallback(() => {
        if (Cookies.get('cs_id_token'))
            // eslint-disable-next-line no-console
            navigate('/logout').catch(console.log)
    }, [])

    useEffect(() => {
        return globalHistory.listen((e) => {
            if (e.location.pathname !== '/fake-sso')
                PageView(e.location.pathname + e.location.search)
        })
    }, [])

    return (
        <>
            <header>
                <EnvironmentName />
                <div className="content grid-container grid-x">
                    <div className="large-12">
                        <img className="logo" src="/assets/images/heart.svg" alt="Caresource" width="100%" height="100%" />
                        <nav>
                            <ul>
                                <li><Link to="/service-requests">Service Postings</Link></li>
                               
                                {/*<li><Link to="/bids">Bid Requests</Link></li>*/}
                            </ul>
                        </nav>
                        <h1>Provider Sourcing</h1>
                    </div>
                </div>
            </header>
            <IdleTimer
                ref={idleTimer}
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                timeout={configData.IdleTimeout}
                onIdle={handleOnIdle}
                debounce={250}
            />
            <div role="main" className="main">
                <div>
                    <article>
                        <div className="content grid-container grid-x">
                            <Router className='large-12 page-content'>
                                <Home path='/' default />
                                <Login path="/login" />
                                <PrivateRoute as={ServiceRequests} path="/service-requests" />
                                {/*<PrivateRoute as={Bids} path="/bids" />*/}
                                <PrivateRoute as={Notifications} path="/notifications" />
                                <PrivateRoute as={Preferences} path="/preferences" />
                                <PrivateRoute as={GuidingCareReplicaAdmin} path="/admin/guidingcare-replica" />
                                <PrivateRoute as={ProviderPreferenceOverrides} path="/admin/provider-preferences" />
                                <PrivateRoute as={Logout} path="/logout" />
                                <PrivateRoute as={FakeSSO} path="/fake-sso" />
                            </Router>
                        </div>
                    </article>
                </div>
            </div>
            <footer>
                <div>
                    <img src="/assets/images/cs-primary-reverse.svg" alt="Caresource" width="100%" height="100%" />
                </div>
                <div className="copyright content grid-container">
                    <p>&copy; Copyright CareSource 2021. All rights reserved.</p>
                </div>
            </footer>
        </>
    )
}

export default App
